import { Paper } from "@material-ui/core";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Image from "../Image";

export default function CustomCarousel({
  itemCount = 1,
  items,
  imageOnly = true,
  ...props
}) {
  const CustomDot = ({ onClick, ...rest }) => {
    const {
      onMove,
      index,
      active,
      carouselState: { currentSlide, deviceType },
    } = rest;

    // onMove means if dragging or swiping in progress.
    // active is provided by this lib for checking if the item is active or not.
    return (
      <div
        className={active ? "active" : "inactive"}
        onClick={() => onClick()}
        style={{
          width: "33px",
          height: "4px",
          backgroundColor: active ? "#0fd3d7" : "#c4c4c4",
          border: "none",
          marginRight: "12px",
          cursor: "pointer",
        }}
      ></div>
    );
  };

  return (
    <Carousel
      responsive={{
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: itemCount || 3,
          slidesToSlide: 1, // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: itemCount || 2,
          slidesToSlide: 1, // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          slidesToSlide: 1, // optional, default to 1.
        },
      }}
      customDot={<CustomDot />}
      infinite={true}
      autoPlay={true}
      // renderDotsOutside={true}
      showDots={true}
      arrows={false}
      swipeable
    >
      {items.map((item, i) => (
        <Item key={i} item={item} imageOnly={imageOnly} />
      ))}
    </Carousel>
  );
}

function Item({ imageOnly, item, ...props }) {
  return (
    <Paper
      style={{
        backgroundColor: "transparent",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {!imageOnly && (
        <p
          style={{
            color: "white",
            fontSize: "18px",
            fontWeight: "600",
            opacity: 0.8,
            marginBottom: "6px",
          }}
        >
          {item.text}
        </p>
      )}

      <Image
        className="d-block w-100"
        src={item.img || item.image}
        alt="Slide"
        draggable={false}
      />
    </Paper>
  );
}
